import React from "react";
import "./popupSummary.css";
import { Trans } from "react-i18next";
import toast from "react-hot-toast";
import { summarizeText } from "../../../utils/translation/deepseek";
import copy from "copy-text-to-clipboard";

interface Props { fullText: string; bookName: string; t: (k: string) => string; onClose: () => void; }
interface State { summary: string; loading: boolean; error: string; done: boolean; }

class PopupSummary extends React.Component<Props, State> {
  private _m = false;
  constructor(p: Props) { super(p); this.state = { summary: "", loading: false, error: "", done: false }; }
  componentDidMount() { this._m = true; }
  componentWillUnmount() { this._m = false; }
  handleGen = async () => {
    this.setState({ loading: true, error: "", summary: "" });
    try {
      const r = await summarizeText(this.props.fullText, (p) => { if (this._m) this.setState({ summary: p }); });
      if (this._m) { this.setState({ summary: r, loading: false, done: true }); toast.success(this.props.t("Summary generated")); }
    } catch (e: any) { if (this._m) this.setState({ error: e.message, loading: false }); }
  };
  render() {
    const { summary, loading, error, done } = this.state;
    const { bookName } = this.props;
    return (
      <div className="psp">
        <div className="psp-header">
          <div className="psp-header-left"><span className="psp-icon">📝</span><div><div className="psp-title"><Trans>Article Summary</Trans></div>{bookName && <div className="psp-subtitle">{bookName}</div>}</div></div>
          <span className="psp-close icon-close" onClick={this.props.onClose}></span>
        </div>
        <div className="psp-body">
          {!done && !loading && (
            <div className="psp-empty"><div className="psp-empty-icon">✨</div><div className="psp-empty-title"><Trans>Generate a summary of this article using AI.</Trans></div><div className="psp-empty-desc">DeepSeek AI will analyze and summarize</div><button className="psp-btn primary" onClick={this.handleGen}><span className="psp-btn-icon">⚡</span><Trans>Generate Summary</Trans></button></div>
          )}
          {loading && (
            <div className="psp-loading"><div className="psp-spinner"></div><div className="psp-loading-text"><Trans>Generating...</Trans></div>{summary && <div className="psp-stream-box"><div className="psp-stream-label">Preview</div><div className="psp-content">{summary}</div></div>}</div>
          )}
          {error && (
            <div className="psp-error"><div className="psp-error-icon">⚠️</div><div className="psp-error-title">Failed</div><div className="psp-error-msg">{error}</div><button className="psp-btn secondary" onClick={this.handleGen}><Trans>Retry</Trans></button></div>
          )}
          {done && !loading && (
            <div className="psp-done"><div className="psp-content-box"><div className="psp-content">{summary}</div></div><div className="psp-actions"><button className="psp-btn secondary" onClick={this.handleGen}><Trans>Regenerate</Trans></button><button className="psp-btn primary" onClick={() => { copy(summary); toast.success(this.props.t("Copied")); }}><Trans>Copy</Trans></button></div></div>
          )}
        </div>
      </div>
    );
  }
}
export default PopupSummary;
